<!-- components/Selectores/SelectMasInput.vue -->
<template>
  <div ref="rootEl" class="relative padrecustom" :class="props.customClassPadre" @click.self="handleOutsideClick">

    <!-- LOADER QUE SIMULA UN INPUT -->
    <div v-if="isLoading"
      class="w-full px-5 rounded-md text-sm font-medium text-gray-900 bg-white border border-gray-200 justify-center inline-flex items-center h-full py-2"
      :class="props.customClassTrigger">
      <LoaderSvg strokeColor="#BD2025" sizeClass="w-4 h-4" />
    </div>

    <!-- desplegable -->
    <template v-else>

      <!-- Selector marca modelo año lo que sea el parrafo -->
      <div v-if="!(abrirOpciones)" @click="isEnabled ? setabrirOpciones() : null" :class="[
        'rounded-md text-center py-2 bg-white select-value',
        isEnabled ? 'cursor-pointer' : 'cursor-not-allowed opacity-60',
        shouldHighlight ? 'border-2 border-[#238B00]' : 'border border-[#e2e8f0]',
        props.customClassTrigger
      ]">


        <p class="flex justify-center items-center pr-1">
          <img v-if="
            props.mostrar_logo_marca &&
            props.placeholderName === 'Marca' &&
            selectedOption !== ''
          " :src="logoOption" class="mr-2 h-6 w-6 object-contain" alt="Logo" />
          {{ displayText }}
        </p>

        <span
          class="border-b-2 border-r-2 p-[2px] rotate-[45deg] -translate-y-1/2 border-black absolute w-[8px] h-[8px] right-3 top-5"></span>
      </div>

      <!-- El input - Con borde verde cuando shouldHighlight es true -->
      <input :type="['Ancho', 'Perfil', 'Aro', 'Año'].includes(props.placeholderName) ? 'number' : 'text'"
        :inputmode="['Ancho', 'Perfil', 'Aro', 'Año'].includes(props.placeholderName) ? 'numeric' : 'text'"
        v-if="abrirOpciones && isEnabled"
        class="z-[9] w-full px-4 py-2 rounded-md input-with-focus resaltar_programatico"
        :class="[shouldHighlight ? 'green-focus' : '', props.customClassInput]" ref="refInput" v-model="search"
        @input="filterOptions" @blur="handleBlur" @focus="handleFocus" @keydown.down.prevent="handleKeyDown"
        @keydown.up.prevent="handleKeyUp" @keydown.enter.prevent="handleEnter" @keypress="isNumber"
        :placeholder="`${props.placeholderName}`" />

      <!-- desplegable -->
      <div ref="listContainer" v-if="abrirOpciones && isEnabled"
        class="touch-scroll z-[100] absolute bg-white w-[100%] text-center rounded-md shadow-xl select-list-container px-2 mt-1 overflow-y-scroll"
        :class="[
          props.placeholderName == 'Marca' ? 'max-h-[290px]' : 'max-h-[200px]',
          props.customClassDropdown
        ]">


        <ul ref="optionsList" class="[&>li]:p-1 my-2 select-list" v-if="filteredOptions.length > 0">
          <li v-for="(option, index) in filteredOptions" :key="isMeasure ? index : option.id"
            @click="selectOption(option, true)" @mouseenter="setHoverIndex(index)"
            :class="{ 'bg-ROJO_LEON text-white': hoverIndex === index, }" class="px-4 py-2 cursor-pointer">

            <span v-if="props.placeholderName === 'Marca'" class="flex justify-center items-center">
              <img v-if="props.mostrar_logo_marca" :src="option.logo" class="mr-2" style="width: 40px" />
              <p>{{ option.name }}</p>
            </span>


            <span v-else-if="isMeasure">{{ option }}</span>
            <span v-else>{{ option.name }}</span>
          </li>
        </ul>

        <ul class="[&>li]:p-1 my-2 select-list" v-else>
          <li>
            <p>Sin resultados</p>
          </li>
        </ul>

      </div>
    </template>
  </div>
</template>

<script setup>

import { computed, ref, nextTick, watch, onMounted, onUnmounted } from "vue";
import LoaderSvg from "~/components/Ui/LoaderSvg.vue";

import { useStore } from 'vuex'
const store = useStore()
const props = defineProps({
  mostrar_logo_marca: { type: Boolean, required: false, default: true },
  data: { type: Array, required: true },
  placeholderName: { type: String, default: "" },
  isLoading: { type: Boolean, default: false },
  isOpen: { type: Boolean, default: false },
  isMeasure: { type: Boolean, default: false },
  hasDefaultOption: { type: Boolean, default: false },
  hasNumberValidation: { type: Boolean, default: false },
  maxNumberLength: { type: Number, default: 0 },
  isEnabled: { type: Boolean, default: true },
  disableAutoScroll: { type: Boolean, default: false },
  selectedValue: { type: [String, Number], default: "" },
  shouldHighlight: { type: Boolean, default: false },
  usar_store_plp: { type: Boolean, default: true },
  plp_namespace: { type: String, default: 'plpModule' },
  customClassPadre: { type: String, default: "" },
  customClassTrigger: { type: String, default: "" },
  customClassInput: { type: String, default: "" },
  customClassDropdown: { type: String, default: "" },

});

const emit = defineEmits(["changeValue", "setSelectMasInput"]);
const rootEl = ref(null);
const vehicleData = computed(() => store.state.plpModule.vehicleData);
const searchVehicleTimestamp = computed(() => store.state.plpModule.searchVehicleTimeStamp);

const search = ref("");
const selectedOption = ref("");
const abrirOpciones = ref(false);
const refInput = ref(null);
const listContainer = ref(null);
const optionsList = ref(null);
const hoverIndex = ref(0);
const logoOption = ref("");
const desplazandose = ref(false);

const options = computed(() => props.data);
const isLoading = computed(() => props.isLoading);
const isMeasure = computed(() => props.isMeasure);
const hasNumberValidation = computed(() => props.hasNumberValidation);
const maxNumberLength = computed(() => props.maxNumberLength);
const isEnabled = computed(() => props.isEnabled);

const cerrarSiEsExterno = (event) => {
  if (!abrirOpciones.value) return;
  if (rootEl.value && !rootEl.value.contains(event.target)) {
    abrirOpciones.value = false;
  }
};

const hasModule = (ns) => {
  try {
    if (typeof store.hasModule === 'function') return store.hasModule(ns)
    return Boolean(store?._modulesNamespaceMap?.[`${ns}/`])
  } catch {
    return false
  }
}

const tiene_mutacion = (type) => {
  try {
    return Boolean(store?._mutations?.[type]?.length)
  } catch {
    return false
  }
}

const ns = computed(() => props.plp_namespace)
const puede_usar_plp = computed(() => props.usar_store_plp && hasModule(ns.value))

const commit_seguro = (mutation, payload) => {
  const type = `${ns.value}/${mutation}`
  if (!puede_usar_plp.value) return
  if (!tiene_mutacion(type)) return
  store.commit(type, payload)
}


// MUESTRA EL VALOR SELECCIONADO O EL PLACEHOLDER
const displayText = computed(() => {
  if (selectedOption.value !== "") {
    return selectedOption.value;
  }
  return props.placeholderName;
});

const filteredOptions = computed(() => {
  return options.value.filter((option) => {
    const isMatch = isMeasure.value
      ? String(option).includes(search.value)
      : typeof option.name === "string"
        ? option.name.toLowerCase().includes(search.value.toLowerCase())
        : String(option.name).includes(search.value);

    return isMatch;
  });
});

const handleFocus = () => {
  // Este método está vacío pero es necesario para asegurar que el evento focus se capture correctamente
};

const isNumber = (event) => {
  if (hasNumberValidation.value) {
    if (!/\d/.test(event.key)) {
      return event.preventDefault();
    }
  }
};

const filterOptions = () => {
  if (isEnabled.value) {
    abrirOpciones.value = true;
  }
};

const selectOption = (option, isUserClick = false) => {
  if (!isEnabled.value) return;

  if (isUserClick) {
    commit_seguro('removeVehicleData')
  }
  const value = isMeasure.value ? option : option.name;

  selectedOption.value = value;
  search.value = value;
  abrirOpciones.value = false;

  if (props.placeholderName === "Marca") {
    logoOption.value = option.logo
    commit_seguro('setSelectedBrandLogo', option.logo)
  }

  emit("changeValue", isMeasure.value ? option : option.id);
};

const setabrirOpciones = async () => {
  if (!isEnabled.value) return;

  // Limpiar búsqueda al abrir/cerrar
  search.value = "";

  // Abrir/cerrar el desplegable
  abrirOpciones.value = !abrirOpciones.value;

  // Avisar al padre qué selector se está manipulando
  emit("setSelectMasInput", props.placeholderName);

  //  Solo si quedó ABIERTO, esperamos el render y enfocamos el input
  if (abrirOpciones.value) {
    await nextTick();   // Esperamos a que el <input> exista en el DOM
    focusInput();       // Enfocamos el input dinámico
  }
};


const setHoverIndex = (index) => {
  hoverIndex.value = index;
};

const handleKeyDown = () => {
  if (hoverIndex.value >= 0 && hoverIndex.value < filteredOptions.value.length - 1) {
    hoverIndex.value++;
  }
  checkScroll();
};

const handleKeyUp = () => {
  if (hoverIndex.value > 0) {
    hoverIndex.value--;
  } else {
    hoverIndex.value = 0;
  }
  checkScroll();
};

const handleEnter = () => {
  selectOption(filteredOptions.value[hoverIndex.value], true);
};

const checkScroll = () => {
  if (optionsList.value && listContainer.value) {
    const itemHeight = optionsList.value.children[0].offsetHeight;
    const containerHeight = listContainer.value.offsetHeight;
    const scrollPosition = itemHeight * hoverIndex.value;
    const middleOfContainer = containerHeight / 2;

    if (scrollPosition < listContainer.value.scrollTop + middleOfContainer) {
      listContainer.value.scrollTop = scrollPosition - middleOfContainer;
    } else if (scrollPosition + middleOfContainer > listContainer.value.scrollTop + containerHeight) {
      const scrollTo = scrollPosition - middleOfContainer;
      listContainer.value.scrollTop = scrollTo;
    }
  }
};

const focusInput = () => {
  if (!refInput.value || !isEnabled.value) {
    return;
  }

  desplazandose.value = true;
  refInput.value.focus();

  //  Opcional: seleccionar todo el contenido actual del input
  try {
    refInput.value.select();
  } catch (e) {
    // En algunos navegadores muy viejos type="number" puede no soportar select(); lo ignoramos silenciosamente
  }

  if (!props.disableAutoScroll) {
    const screenWidth = window.innerWidth;
    const isMobile = screenWidth <= 768;
    const isTablet = screenWidth > 768 && screenWidth <= 1800;

    let alturaFija;
    if (isMobile) {
      alturaFija = 400;
    } else if (isTablet) {
      alturaFija = 104;
    } else {
      alturaFija = 0;
    }

    window.scrollTo({
      top: alturaFija,
      left: 0,
      behavior: 'smooth'
    });
  }

  setTimeout(() => {
    desplazandose.value = false;
  }, 1000);
};

const findOptionByValue = (options, value) => {
  return options.find((option) => {
    if (typeof value === "string") {
      return typeof option.name === "string"
        ? option.name.toLowerCase() === value.toLowerCase()
        : String(option.name) === value;
    } else if (typeof value === "number") {
      return option.id === value;
    }
    return false;
  });
};

const handleGlobalScroll = () => {
  if (abrirOpciones.value == true && desplazandose.value == false) {
    abrirOpciones.value = false;
  }
};

const handleBlur = () => {
  setTimeout(() => {
    abrirOpciones.value = false;
  }, 200);
};

const handleOutsideClick = (event) => {
  if (!abrirOpciones.value) return;

  const currentElement = event.currentTarget;
  let targetElement = event.target;
  let isInside = false;

  while (targetElement) {
    if (targetElement === currentElement) {
      isInside = true;
      break;
    }
    targetElement = targetElement.parentElement;
  }

  if (!isInside) {
    abrirOpciones.value = false;
  }
};

watch(() => props.isOpen, async (newValue) => {
  if (newValue) {
    abrirOpciones.value = true;
    await nextTick();
    focusInput();
  } else {
    abrirOpciones.value = false;
  }
});

watch(() => props.selectedValue, (newValue) => {
  if (newValue !== null && newValue !== undefined && newValue !== "") {
    if (isMeasure.value) {
      selectedOption.value = newValue;
      search.value = newValue;
    } else {
      const foundOption = findOptionByValue(options.value, newValue);
      if (foundOption) {
        selectedOption.value = foundOption.name;
        search.value = foundOption.name;
        if (props.placeholderName === "Marca") {
          logoOption.value = foundOption.logo;
        }
      }
    }
  } else {
    // LIMPIAR CUANDO selectedValue ES VACÍO
    selectedOption.value = "";
    search.value = "";
  }
}, { immediate: true });

onMounted(() => {
  window.addEventListener("scroll", handleGlobalScroll);
  document.addEventListener("mousedown", cerrarSiEsExterno);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleGlobalScroll);
  document.removeEventListener("mousedown", cerrarSiEsExterno);
});

</script>


<style scoped>
.padrecustom {
  min-height: 44px;
  height: 44px;
}

.touch-scroll {
  touch-action: pan-y;
  user-select: none;
}

.select-value {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

input {
  box-sizing: border-box;
  outline: none !important;
  height: 100%;
  text-align: center;
}

input:focus {
  outline: none !important;
  box-shadow: none !important;
}

.select-list-container::-webkit-scrollbar {
  width: 8px;
}

.select-list-container::-webkit-scrollbar-thumb {
  background-color: #363636;
  border-radius: 4px;
}

.select-list-container::-webkit-scrollbar-track {
  background-color: #f3f4f6;
  border-radius: 4px;
}

.select-list-container {
  scrollbar-color: #363636 #f3f4f6;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
  user-select: none;
}

.select-list li {
  min-height: 2.2rem;
}

@supports (-webkit-touch-callout: none) {
  .select-list-container {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.input-with-focus:focus {
  border: 2px solid #238B00 !important;
  outline: none !important;
  box-shadow: none !important;
  caret-color: #238B00;
}

.green-focus {
  border: 2px solid #238B00 !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>